module.exports = __webpack_public_path__ + "img/icon／qsy／kwjj.d9cec136.png";